export const isFullName = nome => {
  const nomeParts = nome.trim().split(' ');
  return nomeParts.length >= 2;
};
